/**
* Ix.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
*/
import { getCookieValue, isValueAssigned, isXhrSupported, safeGetCookieMgr } from "@microsoft/applicationinsights-core-js";
function _getAnid(cookieMgr, webResult) {
    if (webResult && isValueAssigned(webResult.anid)) {
        return webResult.anid;
    }
    return getCookieValue(cookieMgr, "ANON").slice(0, 34);
}
var Ix = /** @class */ (function () {
    function Ix(_config, core) {
        this._config = _config;
        this.core = core;
        this.isEnabled = false;
        this.isSyncDone = false;
        this.isEnabled = this._config && (this._config.adobe === true || this._config.google === true);
        this._cookieMgr = safeGetCookieMgr(core);
    }
    Ix.prototype.getIsEnabled = function () {
        return this.isEnabled;
    };
    Ix.prototype.idSync = function (responseText) {
        try {
            if (this.isEnabled && !this.isSyncDone && responseText) {
                var response = JSON.parse(responseText);
                if (isValueAssigned(response.webResult)) {
                    if (this._config.adobe === true) {
                        var anid = _getAnid(this._cookieMgr, response.webResult);
                        if (isValueAssigned(response.webResult.mc1) || isValueAssigned(anid)) {
                            var requestSrc = this._getAdobeUrl(response.webResult.mc1, anid);
                            if (isXhrSupported()) {
                                var request = new XMLHttpRequest();
                                request.open("GET", requestSrc, true);
                                request.setRequestHeader("Accept", "application/json; charset=utf-8");
                                request.send();
                            }
                        }
                    }
                    if (this._config.google === true) {
                        if (isValueAssigned(response.webResult.mc1)) {
                            var requestSrc = this._getGoogleUrl(response.webResult.mc1);
                            var newImage = new Image();
                            newImage.src = requestSrc;
                        }
                    }
                    this.isSyncDone = true;
                }
            }
        }
        catch (ex) {
            // Empty
        }
    };
    /// <summary> This method returns the URL for the Adobe ID sync </summary>
    /// <returns type="string"> adobe url </returns>
    Ix.prototype._getAdobeUrl = function (mc1, anid) {
        var mc1IdKey = "88170%01";
        var anidKey = "88169%01";
        var qpSeparation = "%01";
        var versionAndSuffix = "&d_ver=2";
        var authStatus = "%010";
        var url = "https://dpm.demdex.net/id?d_orgid=EA76ADE95776D2EC7F000101@AdobeOrg&d_cid=";
        if (isValueAssigned(mc1)) {
            url += mc1IdKey + mc1 + authStatus;
        }
        if (isValueAssigned(anid)) {
            if (isValueAssigned(mc1)) {
                url += qpSeparation;
            }
            url += anidKey + anid + authStatus;
        }
        url += versionAndSuffix;
        return url;
    };
    /// <summary> This method returns the URL for the Adobe ID swap </summary>
    /// <returns type="string"> google url </returns>
    Ix.prototype._getGoogleUrl = function (mc1) {
        return "https://ad.doubleclick.net/ddm/activity/src=6952136;type=store0;cat=oneds;u58=" +
            mc1 + ";match_id=" + mc1 + ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1?";
    };
    return Ix;
}());
export { Ix };
//# sourceMappingURL=Ix.js.map